// src/pages/PropertyBoostPage.jsx
import React from "react";
import { motion } from "framer-motion";
import PropertyBoost from "../components/PropertyBoost";

const PropertyBoostPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <PropertyBoost />
    </motion.div>
  );
};

export default PropertyBoostPage;

